import { Subnav } from '@monorepo/shared/componentsV2/Subnav';
import { SubnavHeaderWithProjectSelect } from '@monorepo/shared/componentsV2/Subnav/SubnavHeaderWithProjectSelect';
import React from 'react';

const options = [
  {
    href: `calendar`,
    label: 'Compliance Calendar',
    subtext: 'Due dates for scheduled inspections, logs and tasks',
  },
  {
    href: `inspections`,
    label: 'Inspections',
    subtext: 'Inspections and forms',
  },
  {
    href: `logs`,
    label: 'Logs',
    subtext: 'Log and view data',
  },
  {
    href: `records`,
    label: 'Records',
    subtext: 'Water sampling and rain log',
  },
  {
    href: `documents`,
    label: 'Documents',
    subtext: 'Site files and folders',
  },
  {
    href: `users`,
    label: 'Users',
    subtext: 'Manage site access',
  },
  {
    href: `site-details`,
    label: 'Site Details',
    subtext: 'Site tags, name, and address',
  },
];

export function ProjectSubnav() {
  return (
    <Subnav
      header={<SubnavHeaderWithProjectSelect />}
      navAriaLabel="Sites"
      optionSections={[{ options }]}
    />
  );
}
